import { FC } from 'react';
import { Button, Modal } from 'rsuite';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onFinish: () => void;
}

export const FinishRoomModal: FC<Props> = ({ isOpen, onClose, onFinish }) => (
  <Modal show={isOpen} onHide={onClose} size="xs">
    <Modal.Header>
      <Modal.Title>鑑定を終了しますか？</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>＊誤って終了した場合は運営までお問い合わせください</p>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="subtle">
        キャンセル
      </Button>
      <Button onClick={onFinish} color="blue" appearance="primary">
        鑑定終了
      </Button>
    </Modal.Footer>
  </Modal>
);
